export default { sha: '6c7c974863020861cdf185eadb13ecc51a08ee85', buildNumber: 'undefined' }
